import { IModel, IViolation } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';

import { DataFlowExpression } from './dataflowexpression';
import { sanitizeAndFormatString } from '../../shared/utils/string.util';
import { BaseRowModifierTransformation } from './base-row-modifier-transformation';

@Metamodel.model({
    name: 'filtertransformation',
    display: [stringResources.Filter, stringResources.FilterTransformationPluralLabel],
    referable: true,
    constraints: {
        name: {
            required: true
        }
    }
})
export class FilterTransformation extends BaseRowModifierTransformation {
    public static readonly MODEL: IModel;
    public transformationLabel = stringResources.Filter;

    @Metamodel.attribute({
        display: stringResources.Expression,
        constraint: {
            validator: FilterTransformation.validateExpression
        }
    })
    public condition: DataFlowExpression = BaseRowModifierTransformation.createExpression(this);

    public static validateExpression(transformation: FilterTransformation): IViolation[] {
        const violations: IViolation[] = [];
        if (!transformation.condition.expression) {
            violations.push({
                context: transformation,
                message: () => sanitizeAndFormatString(stringResources.FilterNoExpressionDescription, transformation.name)
            });
            return violations;
        } else if (!transformation.condition.returnsCorrectType) {
            violations.push({
                context: transformation,
                message: () => stringResources.DataFlow_ShouldReturnBoolean
            });
            return violations;
        }
        return undefined;
    }

    public getExpressions(): DataFlowExpression[] {
        return [this.condition];
    }

    protected get descriptionMsg(): string {
        return stringResources.FilterDescription;
    }

    protected get noDescriptionMsg(): string {
        return stringResources.FilterNoExpressionDescription;
    }
}
